export default __webpack_public_path__ + "static/1297-eb984164e4d8359e9efe1da39c683fe7.png";